import {
  all, call, put, takeLatest,
} from 'redux-saga/effects';
import TaxesActionType from 'actions/taxes/taxesActionType';
import {
  saveDepositTaxes, saveWithdrawalTaxes, saveTaxSetting, saveBetTaxes,
} from 'actions/taxes/taxesActionCreator';
import {
  changeLoadingState, setSuccessMessage, setErrorMessage, changeEndedStatus,
} from 'app/settings/slices';
import NetworkService from 'services/networkService';
import { i18n } from 'services';

import { AppConstants } from 'constants/index';
import { getError, getMessage } from 'utils/helpers';
import { isJSON } from 'utils/utils';

function* getDepositTaxes({ payload }) {
  try {
    const { brandId } = payload;
    const { BrandAdmin, Taxes, Deposit } = AppConstants.api;
    yield put(changeLoadingState(true));
    const { data } = yield call(NetworkService.makeAPIGetRequest, [BrandAdmin, Taxes, brandId, Deposit]);
    yield put(saveDepositTaxes(data));
    yield put(changeLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* editDepositTaxes({ payload }) {
  try {
    const { brandId, data } = payload;
    const { BrandAdmin, Taxes, Deposit } = AppConstants.api;
    const options = {
      data,
    };
    yield put(changeLoadingState(true));
    yield call(NetworkService.makeAPIPostRequest, [BrandAdmin, Taxes, brandId, Deposit], options);
    yield put(setSuccessMessage(getMessage(i18n.t('taxes'), i18n.t('notification:plUpdated'))));
    yield put(changeLoadingState(false));
    yield put(changeEndedStatus(true));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* getWithdrawalTaxes({ payload }) {
  try {
    const { brandId } = payload;
    const { BrandAdmin, Taxes, Withdrawal } = AppConstants.api;
    yield put(changeLoadingState(true));
    const { data } = yield call(NetworkService.makeAPIGetRequest, [BrandAdmin, Taxes, brandId, Withdrawal]);
    yield put(saveWithdrawalTaxes(data));
    yield put(changeLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* editWithdrawalTaxes({ payload }) {
  try {
    const { brandId, data } = payload;
    const { BrandAdmin, Taxes, Withdrawal } = AppConstants.api;
    const options = {
      data,
    };
    yield put(changeLoadingState(true));
    yield call(NetworkService.makeAPIPostRequest, [BrandAdmin, Taxes, brandId, Withdrawal], options);
    yield put(setSuccessMessage(getMessage(i18n.t('taxes'), i18n.t('notification:plUpdated'))));
    yield put(changeLoadingState(false));
    yield put(changeEndedStatus(true));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* getTaxSetting({ payload }) {
  try {
    const { brandId } = payload;
    const { BrandAdmin, Taxes } = AppConstants.api;
    yield put(changeLoadingState(true));
    const { data } = yield call(NetworkService.makeAPIGetRequest, [BrandAdmin, Taxes, brandId]);
    yield put(saveTaxSetting(data));
    yield put(changeLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* addTaxSetting({ payload }) {
  try {
    const { brandId, data } = payload;
    const { BrandAdmin, Taxes } = AppConstants.api;
    yield put(changeLoadingState(true));
    yield call(NetworkService.makeAPIPostRequest, [BrandAdmin, Taxes, brandId], { data });
    yield put(setSuccessMessage(getMessage(i18n.t('brand:taxSettings'), i18n.t('notification:slUpdated'))));
    yield put(changeLoadingState(false));
    yield put(changeEndedStatus(true));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* getBetTaxes({ payload }) {
  try {
    const { brandId } = payload;
    const { BrandAdmin, Taxes, Bet } = AppConstants.api;
    yield put(changeLoadingState(true));
    const { data } = yield call(NetworkService.makeAPIGetRequest, [BrandAdmin, Taxes, brandId, Bet]);
    yield put(saveBetTaxes(data));
    yield put(changeLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* editBetTaxes({ payload }) {
  try {
    const { brandId, data } = payload;
    const { BrandAdmin, Taxes, Bet } = AppConstants.api;
    const options = {
      data,
    };
    yield put(changeLoadingState(true));
    yield call(NetworkService.makeAPIPostRequest, [BrandAdmin, Taxes, brandId, Bet], options);
    yield put(setSuccessMessage(getMessage(i18n.t('taxes'), i18n.t('notification:plUpdated'))));
    yield put(changeLoadingState(false));
    yield put(changeEndedStatus(true));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

export default function* taxesSaga() {
  yield all([
    takeLatest(TaxesActionType.GET_DEPOSIT_TAXES, getDepositTaxes),
    takeLatest(TaxesActionType.EDIT_DEPOSIT_TAXES, editDepositTaxes),
    takeLatest(TaxesActionType.GET_WITHDRAWAL_TAXES, getWithdrawalTaxes),
    takeLatest(TaxesActionType.EDIT_WITHDRAWAL_TAXES, editWithdrawalTaxes),
    takeLatest(TaxesActionType.GET_TAX_SETTING, getTaxSetting),
    takeLatest(TaxesActionType.ADD_TAX_SETTING, addTaxSetting),
    takeLatest(TaxesActionType.GET_BET_TAXES, getBetTaxes),
    takeLatest(TaxesActionType.EDIT_BET_TAXES, editBetTaxes),
  ]);
}
